
document.addEventListener('DOMContentLoaded', function () {
  const SELECTORS = {
    cartTotal: '.js-cart-total',
    installmentBox: '.installment-box',
    installmentPrice: '.js-installment-price'
  };

  const SETTINGS = {
    installmentParts: 4,
    hideAfterCents: 20000 * 100,
    feeApiUrl: 'https://cms.baadmay.com/Fees?merchant_name=divine-jewels-9637.myshopify.com'
  };

  let lastTotalCents = null;
  let cachedFeeData = null;
  let updateTimer = null;
  let isUpdating = false;

  function parseMoneyToCents(text) {
    if (!text) return 0;

    const clean = String(text)
      .replace(/Rs\.?/gi, '')
      .replace(/PKR/gi, '')
      .replace(/,/g, '')
      .replace(/[^\d.]/g, '')
      .trim();

    const amount = parseFloat(clean);

    if (Number.isNaN(amount)) return 0;

    return Math.round(amount * 100);
  }

  function formatMoney(cents) {
    const amount = cents / 100;

    return new Intl.NumberFormat('en-PK', {
      style: 'currency',
      currency: 'PKR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  }

  function getDomTotalCents() {
    const totalEl = document.querySelector(SELECTORS.cartTotal);

    if (!totalEl) return null;

    const dataSubtotal = totalEl.getAttribute('data-cart-subtotal');

    if (dataSubtotal && !Number.isNaN(Number(dataSubtotal))) {
      return Number(dataSubtotal);
    }

    return parseMoneyToCents(totalEl.textContent);
  }

  function toggleInstallmentBox(totalCents) {
    const boxes = document.querySelectorAll(SELECTORS.installmentBox);

    boxes.forEach(function (box) {
      box.style.display = totalCents >= SETTINGS.hideAfterCents ? 'none' : '';
    });
  }

  async function getCartTotalFromShopify() {
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Unable to fetch Shopify cart');
    }

    const cart = await response.json();

    return cart.total_price || 0;
  }

  async function getBaadMayFeeData() {
    if (cachedFeeData !== null) {
      return cachedFeeData;
    }

    try {
      const response = await fetch(SETTINGS.feeApiUrl, {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Unable to fetch BaadMay fee');
      }

      const data = await response.json();

      cachedFeeData = data;
      return data;
    } catch (error) {
      console.warn('BaadMay fee API failed:', error);
      cachedFeeData = [];
      return [];
    }
  }

  function normalizeFeeNumber(value) {
    const number = Number(value);

    if (Number.isNaN(number)) return 0;

    /*
      If API returns 5, treating it as 5%.
      If API returns 0.05, treating it as 5%.
    */

    if (number > 0 && number < 1) {
      return number * 100;
    }

    return number;
  }

  function getFeePercentFromData(data, installmentParts) {
    if (!data) return 0;

    /*
      Your API is currently returning:
      []

      This function is defensive because BaadMay APIs can return structures like:
      [
        { months: 4, fee: 10 },
        { tenure: 4, percentage: 10 },
        { installment_count: 4, fee_percentage: 10 }
      ]

      Or:
      {
        fee: 10,
        percentage: 10
      }
    */

    if (Array.isArray(data)) {
      if (!data.length) return 0;

      const matched = data.find(function (item) {
        const months =
          item.months ||
          item.month ||
          item.tenure ||
          item.installments ||
          item.installment_count ||
          item.installmentParts;

        return Number(months) === Number(installmentParts);
      });

      const item = matched || data[0];

      return normalizeFeeNumber(
        item.fee_percentage ||
        item.feePercent ||
        item.fee_percent ||
        item.percentage ||
        item.percent ||
        item.fee ||
        0
      );
    }

    return normalizeFeeNumber(
      data.fee_percentage ||
      data.feePercent ||
      data.fee_percent ||
      data.percentage ||
      data.percent ||
      data.fee ||
      0
    );
  }

  function renderInstallment(totalCents, feePercent) {
    toggleInstallmentBox(totalCents);

    if (totalCents >= SETTINGS.hideAfterCents) return;

    const installmentEls = document.querySelectorAll(SELECTORS.installmentPrice);

    if (!installmentEls.length) return;

    const feeCents = Math.round(totalCents * (feePercent / 100));
    const payableCents = totalCents + feeCents;
    const installmentCents = Math.round(payableCents / SETTINGS.installmentParts);

    installmentEls.forEach(function (el) {
      el.textContent = formatMoney(installmentCents);
    });
  }

  async function updateInstallment() {
    if (isUpdating) return;

    const domTotalCents = getDomTotalCents();

    if (domTotalCents === null) return;

    toggleInstallmentBox(domTotalCents);

    if (domTotalCents === lastTotalCents) return;

    lastTotalCents = domTotalCents;

    if (domTotalCents >= SETTINGS.hideAfterCents) return;

    isUpdating = true;

    try {
      const shopifyTotalCents = await getCartTotalFromShopify();

      toggleInstallmentBox(shopifyTotalCents);

      if (shopifyTotalCents >= SETTINGS.hideAfterCents) {
        lastTotalCents = shopifyTotalCents;
        return;
      }

      const feeData = await getBaadMayFeeData();
      const feePercent = getFeePercentFromData(feeData, SETTINGS.installmentParts);

      renderInstallment(shopifyTotalCents, feePercent);
    } catch (error) {
      console.warn('Installment update failed:', error);
      renderInstallment(domTotalCents, 0);
    } finally {
      isUpdating = false;
    }
  }

  function scheduleInstallmentUpdate() {
    clearTimeout(updateTimer);

    updateTimer = setTimeout(function () {
      updateInstallment();
    }, 350);
  }

  function observeCartTotal() {
    const totalEl = document.querySelector(SELECTORS.cartTotal);

    if (!totalEl || totalEl.dataset.baadmayObserved === 'true') return;

    totalEl.dataset.baadmayObserved = 'true';

    const observer = new MutationObserver(function () {
      scheduleInstallmentUpdate();
    });

    observer.observe(totalEl, {
      childList: true,
      characterData: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-cart-subtotal']
    });
  }

  function observeCartDrawerReplacement() {
    const observer = new MutationObserver(function () {
      observeCartTotal();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('change', function (event) {
    if (
      event.target.matches('input[name="updates[]"]') ||
      event.target.closest('cart-items') ||
      event.target.closest('cart-drawer') ||
      event.target.closest('cart-notification')
    ) {
      scheduleInstallmentUpdate();
    }
  });

  document.addEventListener('click', function (event) {
    if (
      event.target.closest('.quantity__button') ||
      event.target.closest('button[name="plus"]') ||
      event.target.closest('button[name="minus"]') ||
      event.target.closest('cart-remove-button') ||
      event.target.closest('[data-cart-remove]') ||
      event.target.closest('[href*="/cart/change"]')
    ) {
      scheduleInstallmentUpdate();
    }
  });

  document.addEventListener('cart:updated', scheduleInstallmentUpdate);
  document.addEventListener('cart:refresh', scheduleInstallmentUpdate);
  document.addEventListener('cart-drawer:updated', scheduleInstallmentUpdate);
  document.addEventListener('cart:change', scheduleInstallmentUpdate);

  observeCartTotal();
  observeCartDrawerReplacement();
  scheduleInstallmentUpdate();
});
